module.exports = __webpack_public_path__ + "img/icon_sports_emobility.0baf4a34.png";